import { useTranslation } from "../../translations/LanguageContext";
import { MAX_TEXT_WORDS, countWords } from "../../helpers/constants";

export function InputBox({ name, text, setText }) {
    const { t } = useTranslation();
    const wordCount = countWords(text);
    const characterCount = text.length;
    const isOverLimit = wordCount > MAX_TEXT_WORDS;

    return (
        <section className="text-input">
            <div className="input-top input-section">
                <p className="input-txt">{t("inputBox.title")}</p>
                <div className="input-buttons">
                    <button className="secondary-btn" onClick={() => setText("")}>{t("inputBox.clear")}</button>
                </div>
            </div>

            <label htmlFor={`input-${name}`}>{t("inputBox.inputLabel", { name })}</label>
            <textarea
                id={`input-${name}`}
                name={`input-${name}`}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder={t("inputBox.placeholder")}
            />

            <div className="input-bottom input-section">
                <p className={isOverLimit ? "input-txt input-txt--error" : "input-txt"}>
                    {t("inputBox.words", { count: wordCount })}
                </p>
                <p className="input-txt">{t("inputBox.characters", { count: characterCount })}</p>
            </div>
            {isOverLimit && (
                <p className="input-txt input-txt--error" role="alert">
                    {t("inputBox.tooLong", { max: MAX_TEXT_WORDS })}
                </p>
            )}
        </section>
    );
}
